import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/software",
    name: "Software",
    component: () => import("@/views/Software.vue"),
    children: [
      {
        path: "hfs",
        component: () => import("@/components/software/Hfs.vue"),
      },
      {
        path: "promax",
        component: () => import("@/components/software/Promax.vue"),
      },
    ],
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/Privacy.vue"),
    children: [
      {
        path: "policy",
        component: () => import("@/components/privacy/PrivacyPolicy.vue"),
      },
      {
        path: "cookies",
        component: () => import("@/components/privacy/CookiesPolicy.vue"),
      },
      {
        path: "encarregado",
        component: () => import("@/components/privacy/Encarregado.vue"),
      },
    ],
  },
  {
    path: "/fluxograma",
    name: "Fluxograma",
    component: () => import("@/views/Fluxograma.vue"),
    children: [
      {
        path: "controle-qualidade",
        component: () =>
          import("@/components/fluxograma/ControleQualidade.vue"),
      },
      {
        path: "processamento-2d-3d-tempo",
        component: () =>
          import("@/components/fluxograma/Processamento2D3DTempo.vue"),
      },
      {
        path: "processamento-2d-profundidade",
        component: () =>
          import("@/components/fluxograma/Processamento2DProfundidade.vue"),
      },
      {
        path: "produtos-entregaveis",
        component: () =>
          import("@/components/fluxograma/ProdutosEntregaveis.vue"),
      },
    ],
  },
  {
    path: "/products",
    name: "Products",
    component: () => import("@/views/Products.vue"),
    children: [
      {
        path: "1/controle-qualidade",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/ControleQualidade.vue"
          ),
      },
      {
        path: "1/correcao-estatica-tomografia",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/CorrecaoEstaticaTomografia.vue"
          ),
      },
      {
        path: "1/eliminacao-eventos-anomalos",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/EliminacaoEventosAnomalos.vue"
          ),
      },
      {
        path: "1/regularizacao-dados-prestack",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/RegularizacaoDadosPrestack.vue"
          ),
      },
      {
        path: "1/supressao-ruidos-coerentes",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/SupressaoRuidosCoerentes.vue"
          ),
      },
      {
        path: "1/analise-velocidade-interativa",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/AnaliseVelocidadeInterativa.vue"
          ),
      },
      {
        path: "1/analise-mute-interativa",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/AnaliseMuteInterativa.vue"
          ),
      },
      {
        path: "1/crs",
        component: () =>
          import("@/components/products/processamento-2d-tempo/CRS.vue"),
      },
      {
        path: "1/migracao-prestack-kirchhoff",
        component: () =>
          import(
            "@/components/products/processamento-2d-tempo/MigracaoPrestackKirchhoff.vue"
          ),
      },
      {
        path: "1/hfe",
        component: () =>
          import("@/components/products/processamento-2d-tempo/HFE.vue"),
      },

      {
        path: "2/analise-velocidade-tomografia",
        component: () =>
          import(
            "@/components/products/processamento-2d-profundidade/AnaliseVelocidadeTomografia.vue"
          ),
      },
      {
        path: "2/migracao-2d-kirchhoff",
        component: () =>
          import(
            "@/components/products/processamento-2d-profundidade/Migracao2DKirchhoff.vue"
          ),
      },
      {
        path: "2/migracao-2d-rtm",
        component: () =>
          import(
            "@/components/products/processamento-2d-profundidade/Migracao2DRTM.vue"
          ),
      },
      {
        path: "3/correcao-estatica-3d",
        component: () =>
          import(
            "@/components/products/processamento-3d-tempo/CorrecaoEstatica3D.vue"
          ),
      },
      {
        path: "3/supressao-ruidos-cross-spread",
        component: () =>
          import(
            "@/components/products/processamento-3d-tempo/SupressaoRuidosCrossSpread.vue"
          ),
      },
      {
        path: "3/regularizacao-5d",
        component: () =>
          import(
            "@/components/products/processamento-3d-tempo/Regularizacao5D.vue"
          ),
      },
      {
        path: "4/migracao-rtm",
        component: () =>
          import(
            "@/components/products/processamento-3d-profundidade/MigracaoRTM.vue"
          ),
      },
    ],
  },
  {
    path: "/infraestrutura-ti",
    name: "Infraestrutura TI",
    component: () => import("@/views/InfraestruturaTI.vue"),
  },
  {
    path: "/modelo-contratacao",
    name: "Contratacao",
    component: () => import("@/views/Contratacao.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
